"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
class ValidationError extends Error {
    constructor(errors) {
        super('ValidationError');
        this.errors = errors;
    }
}
exports.ValidationError = ValidationError;
